import CarCarousel from '@apps/components/CarCarousel';
import { TitleDivider } from '@stack/ui/components';
import isEmpty from 'lodash/isEmpty';

export type SameRangeCarSectionProps = {
  cars: any;
  webView?: boolean;
};

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const SameRangeCarSection: React.FC<SameRangeCarSectionProps> = (
  props
) => {
  const { cars, webView = false } = props;
  // ======================= HOOKS

  // ======================= STATE

  // ======================= API

  // ======================= EVENTS

  // ======================= VARIABLES

  // ======================= RENDER FUNCTIONS

  // ======================= VIEWS
  if (isEmpty(cars)) return null;
  return (
    <TitleDivider title="Same Range">
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <CarCarousel cars={cars ?? []} webView={webView} />
      </div>
    </TitleDivider>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default SameRangeCarSection;
